import { render, staticRenderFns } from "./previewordetaildialog.vue?vue&type=template&id=bba75382&scoped=true&"
import script from "./previewordetaildialog.vue?vue&type=script&lang=js&"
export * from "./previewordetaildialog.vue?vue&type=script&lang=js&"
import style0 from "./previewordetaildialog.vue?vue&type=style&index=0&id=bba75382&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba75382",
  null
  
)

export default component.exports